// extracted by mini-css-extract-plugin
export default {"layout":"saved-lists_layout__BKkZ2","row":"saved-lists_row__EqNh1","sub":"saved-lists_sub__jdMK3","listNote":"saved-lists_listNote__5b0IJ","panelHead":"saved-lists_panelHead__WK2E7"};